const selectors = {
  gallery: '[data-gallery]',
  progressBar: '[data-progress-bar]',
}

class ComponentProductInfo extends HTMLElement {
  #activeIndex = 0;

  constructor() {
    super();

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const scrollLeft = this.gallery.scrollLeft;
    const itemWidth = window.innerWidth;
    const scrollWidth = this.gallery.scrollWidth;

    const progress = (scrollLeft + itemWidth) / scrollWidth;

    const activeIndex = Math.round((scrollLeft / (scrollWidth - itemWidth)) * (this.gallery.children.length - 1));

    if (activeIndex !== this.#activeIndex) {
      this.#activeIndex = activeIndex;
      this.container.dataset.activeIndex = this.#activeIndex;
    }

    this.progressBar?.style.setProperty('--progress', progress);
  }

  connectedCallback() {
    this.container = this;
    this.gallery = this.querySelector(selectors.gallery);
    this.progressBar = this.querySelector(selectors.progressBar);

    this.gallery?.addEventListener('scroll', this.handleScroll);
  }
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', ComponentProductInfo);
}